import React, { useState } from 'react';
import axios from 'axios';
import kycImage from './kyc1.png';
import logo from './c_logo.png'; // Import the logo

const Login = ({ setStep, setEmail }) => {
  const [email, setEmailInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailFocused, setEmailFocused] = useState(false);

  const handleSendOtp = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      await axios.post('https://backend-22l3.onrender.com/api/emails/send-otp', { email });
      setEmail(email);
      setStep(2);
    } catch (err) {
      alert('Failed to send OTP');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.mainContainer}>
      <div style={styles.headerContainer}>
        <div style={styles.headerTitle}>Coin Street - Online KYC Portal</div>
        <img src={logo} alt="Company Logo" style={styles.logo} />
      </div>
      
      <div style={styles.contentContainer}>
        <div style={styles.formSection}>
          <h2 style={styles.verifyTitle}>Enter Your Email</h2>
          
          <div style={styles.inputGroup}>
            <div style={styles.floatingLabelContainer}>
              <label 
                style={{
                  ...styles.floatingLabel,
                  ...((emailFocused || email) && styles.floatingLabelFocused),
                  ...(emailFocused && { color: '#0033a0' })
                }}
              >
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmailInput(e.target.value)}
                onFocus={() => setEmailFocused(true)}
                onBlur={() => setEmailFocused(false)}
                style={{
                  ...styles.textInput,
                  ...(emailFocused && styles.inputFocused)
                }}
                required
              />
            </div>
          </div>
          
          <div style={styles.buttonGroup}>
            <button 
              onClick={handleSendOtp} 
              disabled={loading} 
              style={styles.verifyButton}
            >
              {loading ? 'Sending...' : 'Get OTP'}
            </button>
          </div>
        </div>
        
        <div style={styles.illustrationSection}>
          <img src={kycImage} alt="KYC Illustration" style={styles.kycIllustration} />
        </div>
      </div>
      
      <div style={styles.footer}>
        <div style={styles.footerText}>SEBI RIA: INA000001382</div>
        <div style={styles.footerText}>www.coinstreet.in</div>
        <div style={styles.footerText}>support@coinstreet.in</div>
      </div>
    </div>
  );
};

const styles = {
  mainContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    margin: 0,
    fontFamily: 'Poppins, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    overflow: 'hidden',
    justifyContent: 'space-between'
  },
  headerContainer: {
    flex: '0 0 54px', // Reduced from 60px
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 18px', // Reduced from 20px
    backgroundColor: '#fff',
    boxShadow: '0 1.8px 4.5px rgba(0, 0, 0, 0.1)', // Reduced shadow
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    width: '100%',
    boxSizing: 'border-box'
  },
  headerTitle: {
    fontSize: 'calc(12.6px + 0.72vw)', // Reduced by 10%
    fontWeight: 'bold',
    color: '#0033a0',
    '@media (max-width: 768px)': {
      fontSize: '14.4px' // Reduced from 16px
    }
  },
  logo: {
    height: '72px', // Reduced from 80px
    objectFit: 'contain',
    '@media (max-width: 768px)': {
      height: '54px' // Reduced from 60px
    }
  },
  contentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '18px', // Reduced from 20px
    paddingLeft: '9%', // Reduced from 10%
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 992px)': {
      flexDirection: 'column-reverse',
      padding: '9px', // Reduced from 10px
      paddingLeft: '4.5%' // Reduced from 5%
    }
  },
  formSection: {
    flex: '0 0 36%', // Reduced from 40%
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '13.5px', // Reduced from 15px
    padding: '0 18px', // Reduced from 20px
    maxWidth: '450px', // Reduced from 500px
    width: '100%',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 992px)': {
      flex: '1 0 auto',
      maxWidth: '100%',
      margin: '0',
      padding: '18px 9px' // Reduced from 20px 10px
    }
  },
  verifyTitle: {
    fontSize: '21.6px', // Reduced from 24px
    fontWeight: 'bold',
    color: '#0033a0',
    marginBottom: '9px', // Reduced from 10px
    '@media (max-width: 768px)': {
      fontSize: '18px', // Reduced from 20px
      marginBottom: '4.5px' // Reduced from 5px
    }
  },
  inputGroup: {
    width: '100%',
    marginBottom: '18px', // Reduced from 20px
    '@media (max-width: 768px)': {
      marginBottom: '13.5px' // Reduced from 15px
    }
  },
  floatingLabelContainer: {
    position: 'relative',
    width: '100%'
  },
  floatingLabel: {
    position: 'absolute',
    left: 10.8, // Reduced from 12
    top: 10.8, // Reduced from 12
    color: '#999',
    fontSize: '12.6px', // Reduced from 14px
    pointerEvents: 'none',
    transition: 'all 0.2s ease',
    backgroundColor: 'transparent',
    padding: '0 3.6px' // Reduced from 4px
  },
  floatingLabelFocused: {
    top: -7.2, // Reduced from -8
    left: 7.2, // Reduced from 8
    fontSize: '10.8px', // Reduced from 12px
    backgroundColor: '#fff',
    padding: '0 3.6px' // Reduced from 4px
  },
  textInput: {
    width: '100%',
    padding: '10.8px', // Reduced from 12px
    borderRadius: '3.6px', // Reduced from 4px
    border: '1px solid #ccc',
    fontSize: '12.6px', // Reduced from 14px
    boxSizing: 'border-box',
    marginBottom: '13.5px', // Reduced from 15px
    outline: 'none',
    transition: 'all 0.3s ease'
  },
  inputFocused: {
    border: '1.8px solid #0033a0', // Reduced from 2px
    boxShadow: '0 0 0 1.8px rgba(0, 51, 160, 0.2)' // Reduced from 2px
  },
  buttonGroup: {
    display: 'flex',
    gap: '13.5px', // Reduced from 15px
    marginTop: '9px', // Reduced from 10px
    justifyContent: 'left'
  },
  verifyButton: {
    padding: '9px 18px', // Reduced from 10px 20px
    backgroundColor: '#0033a0',
    color: 'white',
    border: 'none',
    borderRadius: '3.6px', // Reduced from 4px
    cursor: 'pointer',
    fontWeight: 'bold',
    width: '135px', // Reduced from 150px
    fontSize: '12.6px', // Reduced from 14px
    transition: 'background-color 0.3s',
    ':hover': {
      backgroundColor: '#002080'
    }
  },
  illustrationSection: {
    flex: '0 0 49.5%', // Reduced from 55%
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 992px)': {
      flex: '0 0 auto',
      width: '100%',
      maxHeight: '27vh', // Reduced from 30vh
      margin: '0 0 9px 0', // Reduced from 10px
      transform: 'none'
    }
  },
  kycIllustration: {
    maxWidth: '100%',
    maxHeight: '81%', // Reduced from 90%
    objectFit: 'contain',
    '@media (max-width: 992px)': {
      maxHeight: '90%'
    }
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '13.5px 9px', // Reduced from 15px 10px
    backgroundColor: '#fff',
    flexWrap: 'wrap',
    flexShrink: 0,
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      gap: '4.5px', // Reduced from 5px
      padding: '9px' // Reduced from 10px
    }
  },
  footerText: {
    flex: '1 0 auto',
    textAlign: 'center',
    fontSize: '19.8px', // Reduced from 22px
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
    color: '#012C9C',
    margin: '0 18px', // Reduced from 20px
    '@media (max-width: 768px)': {
      fontSize: '10.8px', // Reduced from 12px
      margin: '1.8px 0' // Reduced from 2px 0
    }
  }
};

export default Login;